import React from "react";
import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { ADD_DISH } from "../gql/mutations";
import Category from "../../../utils/category";
import SectionHeader from "../../../components/SectionHeader";

const AddDishForm = ({ dishes, setDishes }) => {
    const { register, handleSubmit, reset } = useForm();

    const [addDish] = useMutation(ADD_DISH);

    const onSubmit = async (dishData) => {
        try {
            const { data } = await addDish({
                variables: {
                    dishName: dishData.dishName,
                    category: dishData.category,
                },
            });
            const updatedDishes = [...dishes, dishData];
            setDishes(updatedDishes);

            reset({
                dishName: '',
                category: '',
            })
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <SectionHeader title="Add Dishes" className='sectionHeader' />
            <form onSubmit={handleSubmit(onSubmit)} className="addDishForm">
                <input {...register("dishName", { required: true })} placeholder="Name"></input>
                <select {...register("category", { required: true })} defaultValue="" placeholder="Category">
                    <option disabled value="">-- Dish Category --</option>
                    {Object.keys(Category).map(category => (
                        <option key={category} value={Category[category]}>{Category[category]}</option>
                    ))}
                </select>
                <input type="submit" value="Add Dish"></input>
            </form>
        </>
    )
};

export default AddDishForm;
